export default __webpack_public_path__ + "static/media/bg-space.bb20012a.jpg";